module.exports = __webpack_public_path__ + "static/sp-b0d946ad6cd6e5e61af18c338829abd9.png";